module.exports = __webpack_public_path__ + "static/media/tooth.f84d80c7.png";